import React from "react";
import format from "date-fns/format";
import "./cricket.m.css";

function Scheduled({ nextm }) {
  const rows = nextm;
  if (!rows.length) return null;
  const data = rows[0];
  const url = "/sport/cricket/asia-cup-match-center";
  return (
    <div styleName="scheduled">
      <div styleName="title">
        <div styleName="icon">
          <img src="https://images.assettype.com/gulfnews/2025-08-18/6j3shdtj/cricket.svg" />
        </div>
        <div styleName="name">
          ASIA
          <br />
          CUP
        </div>
        <div styleName="is-scheduled">
          <div styleName="scheduled-dot-tag">
            <span styleName="tag">NEXT</span>
          </div>
        </div>
      </div>
      <a href={url + "?id=" + data.match_id}>
        <div styleName="scheduled-item">
          <p>{data.participants[0].short_name}</p>vs&nbsp;<p>{data.participants[1].short_name}</p>|&nbsp;
          {format(new Date(data.start_date), "HH:mm, dd/MM")}
        </div>
      </a>
    </div>
  );
}
export default Scheduled;
